<template>
  <modal
    name="modal--edit-vendor"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="350"
    :height="'auto'"
    :adaptive="true"
    :reset="true"
    :scrollable="true"
    draggable=".drag-handler"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    class="py-10"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full rounded-sm justify-between p-4"
    >
      <div
        class="text-center text-4xl mb-3 font-extralight tracking-tight drag-handler"
      >
        {{ this.new === true ? 'New Vendor' : 'Edit Vendor' }}
      </div>

      <form @submit.prevent="handleConfirm" autocomplete="off">
        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
          >Vendor
          <div
            class="text-base font-normal mt-2 p-2 border border-gray-300 rounded-lg"
          >
            <label
              class="block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            >
              Name
              <input
                class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
                type="text"
                v-model.lazy="$v.vendor.name.$model"
                autocomplete="off"
                :disabled="!isAdmin"
              />
            </label>
            <label
              class="mt-2 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            >
              Account
              <input
                class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 focus:bg-gray-100 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
                type="text"
                placeholder="(store account number)"
                v-model.lazy="$v.vendor.account.$model"
                autocomplete="off"
                :disabled="!isAdmin"
              />
            </label>
            <label
              class="mt-2 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            >
              Address
              <input
                class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
                type="text"
                v-model.lazy="vendor.address"
                autocomplete="off"
                :disabled="!isAdmin"
              />
            </label>
          </div>
        </label>

        <div class="mt-4 w-full">
          <label
            class="block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            >Contact Person</label
          >
          <div class="mt-2 p-2 border border-gray-300 rounded-lg">
            <label
              class="block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            >
              Name
              <input
                class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
                type="text"
                placeholder="(store account number)"
                v-model.lazy="vendor.contact"
                autocomplete="off"
                :disabled="!isAdmin"
              />
            </label>
            <label
              class="mt-2 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            >
              Email
              <input
                class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
                type="text"
                v-model.lazy="vendor.email"
                autocomplete="off"
                :disabled="!isAdmin"
              />
            </label>

            <label
              class="mt-2 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            >
              Phone
              <input
                class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
                type="text"
                v-model.lazy="vendor.phone"
                autocomplete="off"
                :disabled="!isAdmin"
              />
            </label>
          </div>
        </div>

        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        >
          Ordering Email
          <div class="normal-case mt-2 p-2 border border-gray-300 rounded-lg">
            <label
              class="block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            >
              Subject Line

              <input
                class="text-base font-normal normal-case focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight truncate focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
                type="text"
                v-model.lazy="vendor.emailSubject"
                autocomplete="off"
                :disabled="!isAdmin"
              />
            </label>

            <todo-list
              ref="emailList"
              :label="'Recipients'"
              placeholder="Add Email"
              :list="vendor.emailRecipients"
              :readonly="!isAdmin"
              @add="add"
              @remove="remove"
              class="text-base font-normal normal-case"
            />
          </div>
        </label>

        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
          for="orderingDays"
          >Ordering Days
          <multiselect
            class="text-base font-normal normal-case focus:shadow-outline focus:outline-none mt-2 rounded-lg"
            v-model="vendor.orderingDays"
            :options="weekdays"
            id="orderingDays"
            :close-on-select="false"
            placeholder="Select days"
            :searchable="false"
            :show-labels="false"
            :multiple="true"
            :clear-on-select="false"
            :allow-empty="true"
            :disabled="!isAdmin"
          />
        </label>

        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
          for="deliveringDays"
          >Delivering Days:
          <multiselect
            class="text-base font-normal normal-case focus:shadow-outline focus:outline-none mt-2 rounded-lg"
            id="deliveringDays"
            v-model="vendor.deliveryDays"
            :options="weekdays"
            :close-on-select="false"
            :searchable="false"
            placeholder="Select days"
            :show-labels="false"
            :multiple="true"
            :clear-on-select="false"
            :allow-empty="true"
            :disabled="!isAdmin"
          />
        </label>

        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        >
          Minimum Order Cost
          <money
            class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
            v-model.lazy="vendor.minimumOrder"
            v-bind="moneyConfig"
            autocomplete="off"
            :disabled="!isAdmin"
          />
        </label>

        <label
          class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
        >
          Minimum Case Order
          <input
            class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
            type="number"
            min="0"
            v-model.number="vendor.minimumCases"
            autocomplete="off"
            :disabled="!isAdmin"
          />
        </label>

        <div class="mt-4 w-full">
          <label
            class="block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            >Quickbooks</label
          >
          <div class="mt-2 p-2 border border-gray-300 rounded-lg">
            <label
              class="block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            >
              Terms
              <input
                class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
                type="text"
                v-model.lazy="vendor.terms"
                autocomplete="off"
                :disabled="!isAdmin"
              />
            </label>
            <label
              class="mt-2 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
            >
              Expense Account
              <input
                class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
                type="text"
                v-model.lazy="vendor.expenseAccount"
                autocomplete="off"
                :disabled="!isAdmin"
              />
            </label>
          </div>
        </div>

        <!-- <div class="mt-6 flex flex-row justify-between text-lg text-gray-900">
          <span>Send missed order notification? </span>
          <s-switch v-model="vendor.notification" />
        </div>

        <transition-expand>
          <div v-if="vendor.notification">
            <label
              class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
              for="notificationHour"
            >
              Notify If Not Ordered By
            </label>
            <div class="mt-2">
              <select
                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
                id="notificationHour"
                v-model="vendor.notificationHour"
                @click.stop
              >
                <option
                  value=""
                  disabled
                  selected
                >select something...</option>
                <option
                  v-for="i in hourNumbers"
                  :key="`${i}-returned`"
                  :value="i"
                  v-text="formatHour(i)"
                />
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </div>
          </div>
        </transition-expand> -->

        <!-- <label class="mt-4 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold">
          Notify If Not Ordered By
          <div class="relative w-full">
            <select
              class="mt-2 block appearance-none w-full bg-gray-200 border border-gray-200 text-base font-normal text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
              v-model="vendor.notificationHour"
              @click.stop
            >
              <option
                v-for="i in hourNumbers"
                :key="`${i}-returned`"
                :value="i"
                v-text="formatHour(i)"
              />
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </label> -->

        <div class="mt-6 flex flex-row justify-between text-lg text-gray-900">
          <span>Is this vendor currently active? </span>
          <s-switch v-model="vendor.active" :disabled="!isAdmin" />
        </div>

        <div class="flex flex-row justify-between mt-6">
          <button
            class="buttonOutline focus:shadow-outline focus:outline-none"
            type="button"
            @click="handleCancel"
          >
            Cancel
          </button>
          <button
            class="ml-4 buttonOutline focus:shadow-outline focus:outline-none"
            v-if="isAdmin && !this.new"
            type="button"
            @click="handleDelete"
          >
            Archive
          </button>
          <button
            v-if="isAdmin"
            class="ml-4 button focus:shadow-outline focus:outline-none"
            type="submit"
          >
            {{ this.new === true ? 'Create' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import { weekdays, hourNumbers } from '@/const.js'
import { newId, formatHour } from '@/utils.js'
import { required } from 'vuelidate/lib/validators'
import TodoList from '@/components/TodoList'
import SSwitch from '@/components/SSwitch'
import { Money } from 'v-money'
//import TransitionExpand from '@/components/TransitionExpand'

export default {
  name: 'ModalEditVendor',
  data() {
    return {
      new: true,
      weekdays,
      hourNumbers,
      vendor: {
        id: null, // invisible to user
        active: true,
        name: null,
        contact: null,
        phone: null,
        email: null,
        address: null,
        account: null,
        orderingDays: [],
        deliveryDays: [],
        minimumOrder: 0,
        minimumCases: 0,
        notificationHour: 10,
        emailRecipients: [],
        emailSubject: null, // internal? auto-generated?
        emailBody: null, // internal? auto-generated?
        terms: null,
        expenseAccount: null,
        status: null
      },
      moneyConfig: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }
  },
  validations: {
    vendor: {
      name: {
        required
      },
      account: {}
    }
  },
  components: {
    Multiselect,
    TodoList,
    SSwitch,
    Money
    //TransitionExpand
  },
  computed: {
    ...mapGetters('storeModule/vendors', ['vendors']),
    ...mapGetters('user', ['isAdmin'])
  },
  methods: {
    formatHour,
    ...mapActions('config', ['setFabVisible']),
    ...mapActions('storeModule/vendors', ['updateItem', 'create', 'delete']),
    hideModal() {
      this.$modal.hide('modal--edit-vendor')
    },
    add(i) {
      this.vendor.emailRecipients.push(i)
    },
    remove(i) {
      let index = this.vendor.emailRecipients.indexOf(i)
      if (index > -1) this.vendor.emailRecipients.splice(index, 1)
    },
    beforeOpen: function(event) {
      // set focus on load, tab focus order? enter

      // If an ID for a product was passed, get that product info, if not, set blank
      if (
        event &&
        event.params &&
        event.params.id &&
        this.vendors[event.params.id]
      ) {
        this.new = false
        // create a local copy of the vendor, not a reference, for temporary editing
        this.vendor = {
          ...this.vendors[event.params.id]
        }
        if (!this.vendor.emailRecipients) {
          this.vendor.emailRecipients = ['']
        }
        if (!Object.prototype.hasOwnProperty.call(this.vendor, 'notification'))
          this.$set(this.vendor, 'notification', false)
      } else {
        this.new = true
        this.vendor.id = newId()
        this.vendor.active = true
        this.vendor.minimumOrder = 0
        this.vendor.minimumCases = 0
        this.vendor.status = 'active'
      }
      this.setFabVisible(false)
    },
    beforeClose: function() {
      let arrayProperties = ['emailRecipients', 'orderingDays', 'deliveryDays']
      Object.keys(this.vendor).forEach(property => {
        if (arrayProperties.includes(property)) {
          this.vendor[property] = new Array()
        } else {
          this.vendor[property] = null
        }
      })
      this.setFabVisible(true)
    },
    handleDelete: function() {
      if (!this.new) this.delete(this.vendor.id)
      //this.updateItem({ id: this.vendor.id, data: { active: false } })
      this.hideModal()
    },
    handleCancel: function() {
      this.hideModal()
    },
    handleConfirm: function() {
      var arr = this.vendor.emailRecipients.filter(function(x) {
        return x !== (undefined || null || '')
      })
      this.vendor.emailRecipients = arr
      if (this.new) {
        this.create({ ...this.vendor })
      } else {
        this.updateItem({ id: this.vendor.id, data: { ...this.vendor } })
      }
      this.hideModal()
    }
  }
}
</script>
